const RiskLookup = {
    NotYetVisited: {
        Text: 'Not Yet Visited',
        Value: 0,
        SortOrder: 1
    },
    High: {
        Text: 'High',
        Value: 1,
        SortOrder: 4
    },
    Medium: {
        Text: 'Medium',
        Value: 2,
        SortOrder: 3
    },
    Low: {
        Text: 'Low',
        Value: 3,
        SortOrder: 2
    },
    NoData: {
        Text: 'No Data',
        Value: -1,
        SortOrder: 0
    }
};

export default RiskLookup;
